import { forwardRef, type Ref, type SVGProps } from "react";
const IconLongPressOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="m24.3 14.47-6.13-.78V8.53a3.46 3.46 0 1 0-6.91 0v10.72c-1-.45-1.79-.82-1.94-.88a3.45 3.45 0 0 0-3.92 1.19 3.4 3.4 0 0 0-.65 2.56 3.45 3.45 0 0 0 1.34 2.28l6.55 4.91a3.46 3.46 0 0 0 2.08.69h9.57a2.64 2.64 0 0 0 2.62-2.31L28 19.24a4.3 4.3 0 0 0-3.7-4.77M26 19l-1.05 8.45a.65.65 0 0 1-.64.56h-9.59a1.47 1.47 0 0 1-.88-.29l-6.55-4.93a1.46 1.46 0 0 1-.57-.95A1.48 1.48 0 0 1 7 20.76a1.45 1.45 0 0 1 1.17-.59 1.6 1.6 0 0 1 .47.08c.2.08 1.8.82 3.2 1.47l1.42.66V8.53a1.46 1.46 0 1 1 2.91 0v6.93l7.86 1A2.27 2.27 0 0 1 26 19"
    />
    <path
      fill="currentColor"
      d="M9.31 12a.9.9 0 0 0 .38-.08 1 1 0 0 0 .54-1.3 4.79 4.79 0 1 1 8.85 0 1 1 0 0 0 1.84.76 6.6 6.6 0 0 0 .52-2.59 6.79 6.79 0 1 0-13.06 2.59 1 1 0 0 0 .93.62"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLongPressOutlineSVG);
ForwardRef.displayName = "IconLongPressOutline";
export { ForwardRef as IconLongPressOutline };
